import { useHexMapController } from './useHexMapController';
import { SettingsOverlay } from './SettingsOverlay';
import './styles.css';
import { t } from '../../i18n/translations';
import type { GameConfig } from '../../config/gameConfig';

type HexMapCanvasProps = {
    configOverride?: Partial<GameConfig>;
    tutorialId?: string | null;
};

export const HexMapCanvas = ({ configOverride, tutorialId }: HexMapCanvasProps) => {
    const { canvasRef, stateRef } = useHexMapController({ configOverride, tutorialId });
    const lang = stateRef.current?.config.ui.language ?? 'en';

    return (
        <div className="hex-map">
            <canvas
                ref={canvasRef}
                className="hex-map__canvas"
                role="img"
                aria-label={t(lang, 'app.hexMapLabel')}
            />
            <SettingsOverlay canvasRef={canvasRef} stateRef={stateRef} />
        </div>
    );
};
